import React, {forwardRef, useCallback, useEffect, useState} from "react";
import {Button, ButtonToolbar, DatePicker, Form, Modal} from 'rsuite';
import {deleteUserCert, updateUserCert} from "../../../service/certService";
import {certModel} from "../../form/models";

const earnedDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);

const EditCertModal = (props) => {
    const { open, handleClose, cert, certs } = props;

    const [localState, setLocalState] = useState({});

    const submitCertEdit = useCallback((isFormValid) => {
        if(!isFormValid) return;
        updateUserCert(localState).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    const submitCertDelete = useCallback(() => {
        deleteUserCert({id: localState.id, userId: localState.userId}).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    useEffect(() => {
        setLocalState({...cert});
    }, [cert]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
            size="md"
        >
            <Modal.Header>
                <Modal.Title>Edit Certification</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Date earned can be edited. If your cert name is incorrect, please delete and reenter the cert.
            </Modal.Body>
            <Form
                layout="horizontal"
                model={certModel}
                onChange={handleFormChange}
                onSubmit={submitCertEdit}
                formDefaultValue={cert}
            >
                <Form.Group>
                    <Form.ControlLabel>Certification Name</Form.ControlLabel>
                    <Form.Control name="certName"
                                  data={certs}
                                  disabled
                                  style={{width: 500}}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>EndDate</Form.ControlLabel>
                    <Form.Control name="dateEarned"  accepter={earnedDateInstance}/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitCertDelete} appearance="primary" color="red">
                            Delete Certification
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default EditCertModal;